import { FormStateType } from "../../../../types";
import { PRODUCT_INFORMATION_CONSTANTS } from "../../../constants";

export const formFieldsState: FormStateType = {
  [PRODUCT_INFORMATION_CONSTANTS.COUNTRY_WHERE_ITEM_WAS_PURCHASED]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [PRODUCT_INFORMATION_CONSTANTS.ORDER_ID]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [PRODUCT_INFORMATION_CONSTANTS.ASIN]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [PRODUCT_INFORMATION_CONSTANTS.PRODUCT_NAME]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [PRODUCT_INFORMATION_CONSTANTS.FULFILMENT_PATH]: {
    value: "",
    errors: [],
    hidden: false,
  },
};
